import PropTypes from 'prop-types';
import qs from 'qs';
import React, { Children, Component } from 'react';
import { connect } from 'react-redux';
import List from './List';
import Exports from './Exports';
import ManageRefunds from './ManageRefunds/';
import Overview from './Overview/Overview';
import { checkChanges } from '../../utils/checkChanges';
import { decodeSearch } from '../../utils/url';
import { fetchM } from '../../actions/fetchM';
import { flashErrorMessage } from '../../actions/flash';


class Opportunities extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      isDeveloperSupervisor: PropTypes.bool,
      isDeveloperSalesManager: PropTypes.bool,
      isDeveloperSalesAdmin: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isAdmin: PropTypes.bool,
    }),
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })

  static List = List
  static ManageRefunds = ManageRefunds;
  static Exports = Exports;
  static Overview = checkChanges(Overview)

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      loading: 0,
      data: {},
      refundToken: '',
      paymentData: null,
    };
  }
  componentDidMount() {
    this.mounted = true;
    const { auth } = this.props;
    const query = decodeSearch(this.props.location.search);
    if (this.props.params.id) {
      this.fetchBooking();
      this.fetchPaymentDetails(this.props.params.id);

      // Check if we are already on the payment section
      if (query.section === 'payment') {
        this.fetchPaymentDetails();
      }

      if (query.section === 'documents') {
        this.fetchDocument();
      }
    }
    if (auth.isHeadquarters || auth.isAdminBasic) {
      this.fetchRefunds({ ...query, status: 'pending' });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id && nextProps.params.id !== this.props.params.id) {
      this.setState({ paymentData: null });
      this.fetchBooking(nextProps.params.id);
      this.fetchPaymentDetails(nextProps.params.id);
    }

    const oldQuery = decodeSearch(this.props.location.search);
    const nextQuery = decodeSearch(nextProps.location.search);

    if (nextQuery.section === 'documents' && oldQuery.section !== 'documents') {
      this.fetchDocument();
    }

    if (nextQuery.section === 'payment' && oldQuery.section !== 'payment') {
      this.fetchPaymentDetails();
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      if (!this.mounted) { res(state); return; }
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(on = false) {
    return new Promise((res) => {
      if (!this.mounted) { res(); return; }
      this.setState(prev => ({
        loading: on ? prev.loading + 1 : Math.max(0, prev.loading - 1),
      }), res);
    });
  }

  async fetchBooking(id) {
    const { store } = this.context;
    const bookingId = id || this.props.params.id;

    if (!bookingId || bookingId === 'undefined') {
      return;
    }

    try {
      await this.setLoading(true);

      const res = await store.dispatch(fetchM(`/opportunity/${bookingId}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));

      if (res && res.ok) {
        const data = await res.json();
        const token = res.headers.get('X-Csrf-Token');
        await this.setComponentState({ data, token });
      }
    } catch (err) {
      Bugsnag.notifyException(err);
    } finally {
      await this.setLoading(false);
    }
  }

  async fetchPaymentDetails(nextId) {
    const { store } = this.context;
    const bookingId = nextId || this.props.params.id;
    if (!bookingId) return;

    try {
      await this.setLoading(true);

      const res = await store.dispatch(fetchM(`/unit_reservation_tokens/opportunity/${bookingId}/`, {
        method: 'GET',
        credentials: 'include',
        ignoreNotFound: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }));

      if (res.ok) {
        const token1 = res.headers.get('X-Csrf-Token');
        const paymentData = await res.json();

        if (this.mounted) {
          this.setState({ unitReservationToken: token1, paymentData });
        }

        if (paymentData && paymentData.id) {
          const res2 = await store.dispatch(fetchM(`/unit_reservation_tokens/${paymentData.id}/`, {
            method: 'GET',
            credentials: 'include',
            ignoreNotFound: true,
            headers: {
              'Content-Type': 'application/json',
            },
          }));

          if (res2.ok) {
            const token2 = res2.headers.get('X-Csrf-Token');
            if (this.mounted) {
              this.setState({ TokenPaymentCSRF: token2 });
            }
          }
        }
      } else if (res.status === 404) {
        if (this.mounted) {
          this.setState({ paymentData: null, TokenPaymentCSRF: null });
        }
      } else {
        const message = await res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
    } catch (err) {
      // silently handled — loading will be cleared in finally
    } finally {
      await this.setLoading(false);
    }
  }

  async fetchDocument() {
    const { store } = this.context;
    const bookingId = this.props.params.id;
    if (!bookingId) return;

    try {
      await this.setLoading(true);

      const res = await store.dispatch(fetchM(`/shared_medias/?parent_type=opportunity&parent_id=${bookingId}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }));

      if (res.ok) {
        const documentData = await res.json();
        if (this.mounted) {
          this.setState({ documentData });
        }
      }
    } catch (err) {
      store.dispatch(flashErrorMessage('Error fetching document infomation'));
    } finally {
      await this.setLoading(false);
    }
  }

  async handleManageOpportunity(status, reason = '', opportunityId = null, cancellationType = '', undoCancellation = false) {
    const { store } = this.context;
    const bookingId = opportunityId || this.props.params.id;

    let token = this.state.token;

    if (opportunityId && opportunityId !== this.props.params.id) {
      try {
        const res = await store.dispatch(fetchM(`/opportunity/${opportunityId}/`, {
          credentials: 'include',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }));
        if (res && res.ok) {
          token = res.headers.get('X-Csrf-Token');
        }
      } catch (err) {
        console.error('Failed to fetch CSRF token for opportunity:', err);
      }
    }

    const bodyPayload = {
      sr_status: status,
    };
    if (status === 'pending_cancellation') {
      bodyPayload.sr_cancellation_reason = reason || '-';
      bodyPayload.sr_cancellation_at = new Date().toISOString();
      // CPI-1226: the scenario picked, 'buyer' or 'error'; omitted when absent, never sent empty.
      if (cancellationType) bodyPayload.sr_cancellation_type = cancellationType;
    } else if (undoCancellation) {
      bodyPayload.sr_cancellation_reason = '';
      bodyPayload.sr_cancellation_type = '';
    }
    try {
      await this.setLoading(true);
      const res = await store.dispatch(fetchM(`/opportunity/${bookingId}/manage/`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(bodyPayload),
      }));

      if (res.ok) {
        if (this.props.params.id) {
          await this.fetchBooking();
        }
      } else {
        const errorText = await res.text();
        store.dispatch(flashErrorMessage({ message: errorText }));
      }
    } catch (err) {
      Bugsnag.notifyException(err);
    } finally {
      await this.setLoading(false);
    }
  }

  async fetchRefunds(q, silentLoad = false) {
    if (!silentLoad) await this.setLoading(true);
    const { store } = this.context;

    // 1. EDIT: Ensure 'pending' is the default if no status is provided
    const query = Object.assign({ status: 'pending' }, q);

    if (!query.page || query.page <= 0) query.page = 1;

    try {
      const queryString = qs.stringify(query) ? `?${qs.stringify(query)}` : '';

      const res = await store.dispatch(fetchM(`/unit_reservation_refunds/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(this.state.refundToken ? { 'X-Csrf-Token': this.state.refundToken } : {}),
        },
      }));

      if (res.ok) {
        const refundData = await res.json();
        const nextToken = res.headers.get('X-Csrf-Token');

        if (this.mounted) {
          this.setState({
            refundData: refundData || [],
            refundToken: nextToken || this.state.refundToken,
            refundCount: parseInt(res.headers.get('M-Data-count'), 10) || 0,
            refundLimit: parseInt(res.headers.get('M-Data-limit'), 10) || 0,
            refundOffset: parseInt(res.headers.get('M-Data-offset'), 10) || 0,
          });
        }
      }
    } catch (e) {
      Bugsnag.notifyException(e);
    } finally {
      if (!silentLoad) await this.setLoading(false);
    }
  }
  renderChild() {
    const childProp = {
      token: this.state.token,
      TokenPaymentCSRF: this.state.TokenPaymentCSRF,
      unitReservationToken: this.state.unitReservationToken,
      refundToken: this.state.refundToken,
      loading: this.state.loading > 0,
      paymentData: this.state.paymentData,
      documentData: this.state.documentData,
      refundData: this.state.refundData,
      refundCount: this.state.refundCount,
      refundLimit: this.state.refundLimit,
      refundOffset: this.state.refundOffset,
      data: this.state.data,
      fetchBooking: () => this.fetchBooking(),
      fetchPaymentDetails: () => this.fetchPaymentDetails(),
      fetchDocument: () => this.fetchDocument(),
      onUpdateOpportunity: (status, reason, targetId, cancellationType, undoCancellation) =>
        this.handleManageOpportunity(status, reason, targetId, cancellationType, undoCancellation),
      fetchRefunds: q => this.fetchRefunds(q),
    };
    if (this.props.params && this.props.params.id) {
      childProp.data = this.state.data;
      childProp.routeParamsID = this.props.params.id || '';
    }
    return Children.map(this.props.children, child => (
      React.cloneElement(child, childProp)
    ));
  }

  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}

export default connect(Opportunities.mapStateToProps)(Opportunities);



// WEBPACK FOOTER //
// ./src/containers/Opportunities/Opportunities.jsx